import { FC } from 'react';
import { Link, useHistory, useLocation } from 'react-router-dom';
import { userLogout } from "../../apis/user";
import { H6 } from '../../components/H6';
import { AIRBRIDGE_EVENT } from "../../constants/airbridge";
import { BRAZE_EVENT } from "../../constants/braze";
import { useUserDispatch } from "../../context/UserContext";
import { Bridge } from "../../plugins/bridge";
import { nToast } from "../../plugins/reactToast";
import { MyPageEventProperties } from '../../types/amplitudeEventProperties';

export const MyPageSidebar = () => {
  const { pathname } = useLocation();
  const dispatch = useUserDispatch();
  const history = useHistory();

  const sendingLog = async function () {
    const appboy = require('@braze/web-sdk');
    await Bridge.sendAirbridge(AIRBRIDGE_EVENT.signOut);
    await Bridge.sendBraze(BRAZE_EVENT.SIGN_OUT);
    Bridge.sendAirbridge("clearUser");
  };

  const logout = () => {
    userLogout().then(async r => {
      dispatch({ type: 'LOGOUT' });
      localStorage.removeItem('authToken');
      nToast(`로그아웃 되었습니다`);
      history.push('/');
    });
  };


  return (
    <>
      <div className="text-13 divide-y divide-gray-200 md:border border-b border-gray-200">
        <H6 className="p-4">나의 주문</H6>

        <div className="flex flex-col divide-y divide-gray-200">
          <MenuItem path={`/mypage/orders`} text="전체 주문 내역" />
          <MenuItem path={`/mypage/cancels`} text="결제 취소 내역" />
          <MenuItem path={`/mypage/refunds`} text=" 교환 · 반품 내역" />
        </div>

        <H6 className="p-4">나의 정보</H6>

        <div className="flex flex-col divide-y divide-gray-200">
          <MenuItem path={`/mypage/edit`} text="회원 정보" />
          {/*<MenuItem path={`/mypage/inquire`} text="1:1 문의하기" />*/}
          <MenuItem path={`/mypage/point`} text="적립금 & 쿠폰" />
        </div>

        <div className="grid grid-cols-2 divide-x divide-gray-200">
          {/*<Link to="/cc/contact-us" className={`p-4 font-semibold`}>*/}
          {/*  고객 질문*/}
          {/*</Link>*/}
          <Link to="/cc/faq" className={`p-4 font-semibold`}>
            자주 하는 질문
          </Link>
        </div>
        <div className="grid grid-cols-2 divide-x divide-gray-200">
          <Link to="/mypage" className={`p-4 font-semibold`} onClick={async () => { await sendingLog(); logout(); }}>
            로그아웃
          </Link>
        </div>
      </div>
    </>
  );
};

interface MenuItemProps {
  text: string;
  path: string;
}

const MenuItem: FC<MenuItemProps> = ({ text, path }) => {
  const { pathname } = useLocation();

  const handleOnClick = () => {
    const myPageTab: MyPageEventProperties = {
      mypage_tab: text
    };
    Bridge.sendAmplitude('mypage_viewed', myPageTab);
  };

  return (
    <Link
      onClick={handleOnClick}
      key={text}
      to={path}
      className={` p-4 text-gray-600 ${pathname.startsWith(path) ? 'text-gray-900 bg-brand-2' : ''
        }`}
    >
      {text}
    </Link>
  );
};
